import api from "./axios";

const PUBLIC_PROJECT_CONFIG_ENDPOINT =
  process.env.REACT_APP_PUBLIC_PROJECT_CONFIG_ENDPOINT || "/public/config";

function unwrap(payload) {
  return payload?.data?.data || payload?.data || payload || {};
}

function cleanIdentity(value) {
  return String(value || "").trim().toLowerCase();
}

function endpointForSlug(slug) {
  const base = String(PUBLIC_PROJECT_CONFIG_ENDPOINT).replace(/\/+$/, "");
  return `${base}/${encodeURIComponent(slug)}`;
}

function canRetryWithSlug(error) {
  return [400, 404].includes(Number(error?.response?.status));
}

async function requestByHostname(hostname) {
  const response = await api.get(PUBLIC_PROJECT_CONFIG_ENDPOINT, {
    params: { hostname },
    headers: {
      "Cache-Control": "no-cache",
      "x-storefront-host": hostname,
      "x-project-domain": hostname,
      // El interceptor general agrega el slug legado cuando existe. Para esta
      // consulta fijamos la identidad primaria al hostname; si no resuelve, la
      // segunda llamada usa el slug explícito como respaldo.
      "x-project-id": hostname,
      "x-wp-project": hostname,
    },
  });

  return unwrap(response);
}

async function requestBySlug(slug) {
  const response = await api.get(endpointForSlug(slug), {
    headers: { "Cache-Control": "no-cache" },
  });

  return unwrap(response);
}

/**
 * Configuración pública y segura de la tienda actual.
 *
 * La identidad primaria es el hostname real del storefront. El slug se usa
 * únicamente como respaldo para previews, desarrollo y proyectos históricos.
 * Nunca debe incluir accessToken, clientSecret ni secretos del comercio.
 */
export async function getPublicProjectConfig({ hostname, slug } = {}) {
  const normalizedHostname = cleanIdentity(hostname);
  const normalizedSlug = cleanIdentity(slug);

  if (normalizedHostname) {
    try {
      return await requestByHostname(normalizedHostname);
    } catch (error) {
      if (!normalizedSlug || !canRetryWithSlug(error)) throw error;
    }
  }

  if (normalizedSlug) return requestBySlug(normalizedSlug);

  const response = await api.get(PUBLIC_PROJECT_CONFIG_ENDPOINT, {
    headers: { "Cache-Control": "no-cache" },
  });

  return unwrap(response);
}
